import { 
    Modal
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { BiError } from 'react-icons/bi';

ModalErro.propTypes = {

    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    msg: PropTypes.string.isRequired,
    funcAoFechar: PropTypes.func

}

export default function ModalErro({showModal, setShowModal, msg, funcAoFechar}) {

    return(

        <Modal
        show={showModal}
        onHide={() => { setShowModal(false); if(funcAoFechar != null){ funcAoFechar(); } } }
        keyboard={false}
        id="modalErro"
        centered
        >
            <Modal.Header closeButton>
                <Modal.Title><h1><BiError /> Erro !</h1></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {msg}
            </Modal.Body>
        </Modal>

    );

}
